import { useDispatch, useSelector } from 'react-redux';
import { Badge, Typography } from 'antd';
import { BellTwoTone } from '@ant-design/icons';
import NoticeList from '@/component/notice';
import { setNoticeCenterOpen } from '@/app/reducers/noticeSlice';
import { useI18n } from '@/i18n';

export default function NoticeHeader() {
  const $t = useI18n('component.header.language');
  const dispatch = useDispatch();
  const { noticeCenterOpen, unreadCount } = useSelector(state => state.notice || {});

  const toggleNoticeOpen = () => {
    dispatch(setNoticeCenterOpen(!noticeCenterOpen));
  };

  return (
    <>
      <Typography.Text title={$t('Message Center')} onClick={toggleNoticeOpen} style={{ cursor: 'pointer' }} >
        <Badge style={{ transform: 'scale(.85)', padding: '0 2px' }} count={unreadCount || 0} size="small" offset={[6, -3]} className="flex-align-center"  >
          <BellTwoTone style={{ fontSize: 21 }} twoToneColor="#000" />
        </Badge>
      </Typography.Text>
      {noticeCenterOpen && <NoticeList open={noticeCenterOpen} toggleNoticeOpen={toggleNoticeOpen} />}
    </>
  );
}